<template>
    <apexchart
        :class="{ 'dark-theme': isDark }"
        type="bar"
        :options="chartOptions"
        :series="series"
        height="300"
    ></apexchart>
</template>

<script>
    import VueApexCharts from 'vue3-apexcharts';

    export default {
        name: 'ChartPanel',
        components: {
            apexchart: VueApexCharts,
        },
        props: {
            data: {
                type: [Array, Object],
                required: true,
            },
            title: {
                type: String,
                default: '',
            },
            nameChart: {
                type: String,
                default: 'Alunos', 
            },
            isDark: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                series: [],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: false,
                        },
                        height: '200px',
                        width: '100%',
                        type: 'bar',
                        zoom: {
                            enabled: false,
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: function (value) {
                                if (
                                    value === null ||
                                    value === undefined ||
                                    isNaN(value)
                                ) {
                                    return '0';
                                }
                                return Number(value).toLocaleString('pt-BR');
                            },
                        },
                    },
                    colors: ['#1AC7D0'],
                    dataLabels: {
                        enabled: false,
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '80%',
                        },
                    },
                    xaxis: {
                        categories: [],
                        labels: {
                            formatter: function (value) {
                                try {
                                    const date = new Date(value);
                                    if (isNaN(date.getTime())) {
                                        return value;
                                    }
                                    const months = [
                                        'Jan',
                                        'Fev',
                                        'Mar',
                                        'Abr',
                                        'Mai',
                                        'Jun',
                                        'Jul',
                                        'Ago',
                                        'Set',
                                        'Out',
                                        'Nov',
                                        'Dez',
                                    ];
                                    return `${
                                        months[date.getMonth()]
                                    } ${date.getFullYear()}`;
                                } catch (e) {
                                    console.error('Error formatting date:', e);
                                    return value;
                                }
                            },
                        },
                    },
                    yaxis: {
                        opposite: false,
                        labels: {
                            formatter: function (value) {
                                if (
                                    value === null ||
                                    value === undefined ||
                                    isNaN(value)
                                ) {
                                    return '0';
                                }
                                return Number(value).toLocaleString('pt-BR');
                            },
                        },
                    },
                    legend: {
                        horizontalAlign: 'left',
                        show: true,
                    },
                },
            };
        },
        methods: {
            resetChart() {
                const currentDate = new Date();
                const currentYear = currentDate.getFullYear();
                const currentMonth = currentDate.getMonth() + 1;
                
                const formattedCurrentMonth = `${currentYear}-${currentMonth.toString().padStart(2, '0')}`;
                
                this.series = [{ name: this.nameChart, data: [0] }];
                this.chartOptions.xaxis.categories = [formattedCurrentMonth];
            },
            processData(newData) {
                if (
                    !newData ||
                    (Array.isArray(newData) && newData.length === 0)
                ) {
                    console.warn('Data is empty or invalid');
                    this.resetChart();
                    return;
                }

                const monthsToNum = {
                    january: '01',
                    february: '02',
                    march: '03',
                    april: '04',
                    may: '05',
                    june: '06',
                    july: '07',
                    august: '08',
                    september: '09',
                    october: '10',
                    november: '11',
                    december: '12',
                };

                const currentYear = new Date().getFullYear();
                let dataArray = Array.isArray(newData) ? newData : [newData];

                const convertedData = dataArray
                    .map((item) => {
                        if (!item || !item.month) {
                            console.warn('Invalid data item:', item);
                            return null;
                        }

                        const monthNumber =
                            monthsToNum[item.month.toLowerCase()];
                        if (!monthNumber) {
                            console.warn(`Invalid month found: ${item.month}`);
                            return null;
                        }

                        const value = parseFloat(item.value);
                        return {
                            x: `${currentYear}-${monthNumber}`,
                            y: isNaN(value) ? 0 : value,
                        };
                    })
                    .filter((item) => item !== null);

                if (convertedData.length === 0) {
                    console.warn('No valid data after conversion');
                    this.resetChart();
                    return;
                }

                convertedData.sort((a, b) => new Date(a.x) - new Date(b.x));

                this.series = [
                    {
                        name: this.nameChart,
                        data: convertedData.map((item) => item.y),
                    },
                ];

                this.chartOptions.xaxis.categories = convertedData.map(
                    (item) => item.x
                );
            },
        },
        watch: {
            data: {
                immediate: true,
                handler(newData) {
                    this.processData(newData);
                },
            },
        },
    };
</script>

<style>
    .vue-apexcharts svg {
        width: auto;
    }
    
    /* Dark mode tooltip styling */
    .dark-theme .apexcharts-tooltip {
        background-color: #444 !important;
        color: white !important;
        border: none !important;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3) !important;
    }
    
    .dark-theme .apexcharts-tooltip-title {
        background-color: #575757 !important;
        color: white !important;
        border-bottom: 1px solid #666 !important;
    }
    
    .dark-theme .apexcharts-tooltip-y-group {
        color: white !important;
    }
</style>
